import React, { useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { EQUIPMENTS } from "../../constants";
import ComingSoon from "../../components/comingSoon/ComingSoon";

const Shop = () => {
  const [cart, setCart] = useState([]);
  const [isCartVisible, setIsCartVisible] = useState(false);

  let ready = false;

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingProductIndex = prevCart.findIndex(
        (item) => item.id === product.id
      );
      if (existingProductIndex !== -1) {
        const updatedCart = structuredClone(prevCart);
        updatedCart[existingProductIndex].quantity += 1;
        return updatedCart;
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  const removeOneFromCart = (productId) => {
    setCart((prevCart) => {
      const existingProductIndex = prevCart.findIndex(
        (item) => item.id === productId
      );
      if (existingProductIndex !== -1) {
        const updatedCart = structuredClone(prevCart);
        if (updatedCart[existingProductIndex].quantity > 1) {
          updatedCart[existingProductIndex].quantity -= 1;
        } else {
          updatedCart.splice(existingProductIndex, 1);
        }
        return updatedCart;
      }
      return prevCart;
    });
  };

  const removeAllFromCart = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== productId));
  };

  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);

  const totalPrice = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const toggleCartVisibility = () => {
    setIsCartVisible(!isCartVisible);
  };

  const handleOrder = () => {
    alert("Thank you for your order!");
    setCart([]);
    setIsCartVisible(false);
  };


  if (!ready) {
    return <ComingSoon />;
  }

  return (
    <div className="container mx-auto p-6 min-h-screen mt-32 relative">
      {/* Cart Icon */}
      <div className="fixed top-28 right-6 z-10">
        <button
          onClick={toggleCartVisibility}
          className="relative bg-baseBlue text-white p-3 rounded-full hover:bg-mediumBlue transition-colors duration-300 shadow-lg"
        >
          <FaShoppingCart className="text-2xl" />
          {totalItems > 0 && (
            <span className="absolute -top-2 -right-2 rounded-full bg-baseGreen text-baseBlue text-xs w-6 h-6 flex items-center justify-center font-bold">
              {totalItems}
            </span>
          )}
        </button>
      </div>

      <h1 className="text-4xl font-extrabold text-center text-baseBlue mb-12">
        Arm Wrestling Equipment Shop
      </h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {EQUIPMENTS.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl border border-gray-100"
          >
            <img
              className="w-full h-64 object-cover"
              src={product.image}
              alt={product.name}
            />
            <div className="p-6">
              <h2 className="text-2xl font-bold text-baseBlue mb-2">
                {product.name}
              </h2>
              <p className="text-gray-600 mb-4">{product.description}</p>
              <p className="text-xl font-semibold text-mediumBlue mb-4">
                ${product.price.toFixed(2)}
              </p>
              <button
                onClick={() => addToCart(product)}
                className="w-full bg-baseGreen text-baseBlue py-3 rounded-xl hover:bg-baseGreen transition-colors duration-300 font-bold shadow-md"
              >
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Cart Modal */}
      {isCartVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-sm md:max-w-lg p-6 relative mx-4">
            <button
              onClick={toggleCartVisibility}
              className="absolute top-4 right-4 text-baseBlue hover:text-mediumBlue"
            >
              <AiOutlineClose className="text-2xl" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold text-baseBlue mb-6">
              Equipment Cart
            </h2>
            {cart.length === 0 ? (
              <p className="text-gray-600">Your cart is empty.</p>
            ) : (
              <>
                <ul className="mb-6 space-y-4">
                  {cart.map((item, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center p-4 bg-gray-50 rounded-lg"
                    >
                      <div className="flex items-center">
                        <span className="font-bold text-baseBlue">{item.name}</span>
                        <div className="ml-4 flex items-center space-x-2">
                          <button
                            onClick={() => removeOneFromCart(item.id)}
                            className="w-8 h-8 bg-baseGreen text-baseBlue rounded-lg hover:bg-baseGreen transition-colors"
                          >
                            -
                          </button>
                          <span className="w-8 text-center">{item.quantity}</span>
                          <button
                            onClick={() => addToCart(item)}
                            className="w-8 h-8 bg-baseGreen text-baseBlue rounded-lg hover:bg-baseGreen transition-colors"
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="font-semibold text-mediumBlue">
                          ${(item.price * item.quantity).toFixed(2)}
                        </span>
                        <button
                          onClick={() => removeAllFromCart(item.id)}
                          className="ml-4 text-baseGreen hover:text-darkGreen"
                        >
                          <AiOutlineClose />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="flex justify-between items-center text-lg font-bold text-baseBlue p-4 bg-gray-50 rounded-lg">
                  <div>Total Items: {totalItems}</div>
                  <div>Total Price: ${totalPrice.toFixed(2)}</div>
                </div>
                <button
                  onClick={handleOrder}
                  className="w-full bg-baseGreen text-baseBlue py-3 rounded-xl mt-6 hover:bg-baseGreen transition-colors duration-300 font-bold shadow-md"
                >
                  Order Now
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Shop;